import { render } from "./CurrentTab.vue?vue&type=template&id=42fc72d6"
import script from "./CurrentTab.vue?vue&type=script&lang=js"
export * from "./CurrentTab.vue?vue&type=script&lang=js"

import "./CurrentTab.vue?vue&type=style&index=0&id=42fc72d6&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__